import type { ReactNode } from 'react';
import { ColorThemeContext, useColorThemeProvider } from './useColorTheme';

export function ColorThemeProvider({ children }: { children: ReactNode }) {
  const value = useColorThemeProvider();
  return <ColorThemeContext.Provider value={value}>{children}</ColorThemeContext.Provider>;
}
